import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { PhoneAccountProvider } from "../../contexts/PhoneAccountContext";
import { LiveChatProvider } from "../../contexts/LiveChatContext";
import { TimezoneProvider } from "../../contexts/TimezoneContext";
import { isAuthenticated, clearAuthAndRedirectToLogin } from "../../utils/auth";
import { initSocket } from "../../utils/socket";

import ThemeLoader from "../ui/ThemeLoader";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = () => {
      if (!isAuthenticated()) {
        clearAuthAndRedirectToLogin();
      } else {
        // Initialize socket early so it's connected when user navigates to live chat
        initSocket();
        setTimeout(() => setIsLoading(false), 500);
      }
    };
    checkUser();
  }, [navigate]);

  const toggleSidebar = () => setSidebarOpen((v) => !v);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Allow scrolling globally
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebarOpen]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center">
        <ThemeLoader
          size="lg"
          message="Loading BluTec PING..."
          submessage="Please wait while your dashboard is prepared"
        />
      </div>
    );
  }

  return (
    <TimezoneProvider>
      <PhoneAccountProvider>
        <LiveChatProvider>
          <div className="flex min-h-screen bg-[#ffff] overflow-x-hidden">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            {/* Main content wrapper - 80px (20rem) margin for sidebar on desktop */}
            <div className="flex-1 lg:ml-20 flex flex-col min-h-screen min-w-0 max-w-full overflow-x-hidden">
              {/* Fixed Header */}
              <Header toggleSidebar={toggleSidebar} />

              {/* Main content with top padding for fixed header */}
              <main className="flex-1 pt-14 md:pt-16 min-w-0 max-w-full overflow-x-hidden">
                <div className="w-full min-w-0 max-w-full overflow-x-hidden">
                  {children}
                </div>
              </main>
            </div>
          </div>
        </LiveChatProvider>
      </PhoneAccountProvider>
    </TimezoneProvider>
  );
};

export default Layout;